import React from 'react';

class SubformDetails extends React.Component {
    showTitle() {
        if (this.props.title) {
            return (
                <h2>{this.props.title}</h2>
            )
        } else {
            return null;
        }
    }
    render() {
        let className = "subform";
        if(this.props.className !== undefined){
            className = className + ' ' + this.props.className
        }
        if (this.props.is_hidden) {
            return null
        } else {
            return (
                <div className={className}>
                    {this.showTitle()}
                    {this.props.children}
                </div>
            )
        }
    }
}

export default SubformDetails;